import "./loader.css";

export const Loader = ({ fullHeight = false }) => {
    return (
        <div className="spinner-container">
            <div className={(fullHeight ? "full-height" : "") + "loading-spinner"}></div>
        </div>
    )
}
